export const DEFAULT_REFERENCE_NUMBER = '9'

export const DEFAULT_REFERENCE_PAYMENT_TYPE = '1'
